import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Modules/uxp/Host Information/Host";
import * as React from 'react';
export default {
  Content,
  React
};